var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s)
        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
            t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { InlineError, InlineSuccess } from '@guardian/src-user-feedback';
import { Label } from '@guardian/src-label';
import { widthFluid, width30, width10, width4, textInput, errorInput, successInput, supportingTextMargin, labelMargin, inlineMessageMargin, } from './styles';
import { descriptionId, generateSourceId, } from '@guardian/src-foundations/accessibility';
const widths = {
    30: width30,
    10: width10,
    4: width4,
};
/**
 * [Storybook](https://guardian.github.io/source/?path=/docs/source-src-text-input-textinput--playground) •
 * [Design System](https://theguardian.design/2a1e5182b/p/097455-text-input-field/b/050445) •
 * [GitHub](https://github.com/guardian/source/tree/main/src/core/components/text-input) •
 * [NPM](https://www.npmjs.com/package/@guardian/src-text-input)
 *
 * Single line fields that allow users to enter freeform data.
 *
 * The following themes are supported: `light`
 */
export const TextInput = (_a) => {
    var { id, label: labelText, optional = false, hideLabel = false, supporting, width, error, success, cssOverrides } = _a, props = __rest(_a, ["id", "label", "optional", "hideLabel", "supporting", "width", "error", "success", "cssOverrides"]);
    const textInputId = id || generateSourceId();
    return (_jsxs(Label, Object.assign({ text: labelText, optional: !!optional, hideLabel: hideLabel, supporting: supporting }, { children: [error && (_jsx("div", Object.assign({ css: inlineMessageMargin }, { children: _jsx(InlineError, Object.assign({ id: descriptionId(textInputId) }, { children: error }), void 0) }), void 0)), !error && success && (_jsx("div", Object.assign({ css: inlineMessageMargin }, { children: _jsx(InlineSuccess, Object.assign({ id: descriptionId(textInputId) }, { children: success }), void 0) }), void 0)), _jsx("input", Object.assign({ css: (theme) => [
                    width ? widths[width] : widthFluid,
                    textInput(theme.textInput && theme),
                    supporting ? supportingTextMargin : labelMargin,
                    error ? errorInput(theme.textInput && theme) : '',
                    !error && success
                        ? successInput(theme.textInput && theme)
                        : '',
                    cssOverrides,
                ], type: "text", id: textInputId, "aria-required": !optional, "aria-invalid": !!error, "aria-describedby": error || success ? descriptionId(textInputId) : '', required: !optional }, props), void 0)] }), void 0));
};
//# sourceMappingURL=TextInput.js.map
